import {
  setPermissionByCategory,
  setSelectedPermissions,
} from "pages/ManageRoles/roleSlice"; // Import the action to update permissions by category
import { useEffect, useState } from "react";
import CheckboxTree from "react-checkbox-tree";
import { useDispatch, useSelector } from "react-redux";
import { TreeClose, TreeOpen } from "themes/Icon";
import "./tree_comp.scss";

function TreeComp({ data, category, viewOnly = false }) {
  const dispatch = useDispatch();
  const { selectedPermissions } = useSelector((state) => state.roles);

  const [expanded, setExpanded] = useState([]);
  const [localChecked, setLocalChecked] = useState(selectedPermissions || []);

  useEffect(() => {
    if (selectedPermissions) {
      setLocalChecked(selectedPermissions);
      setExpanded([]);
    } else {
      setLocalChecked([]);
    }
  }, []);

  const handleCheck = (newChecked) => {
    dispatch(setSelectedPermissions(newChecked));
    setLocalChecked(newChecked);
    dispatch(setPermissionByCategory({ category, permissions: newChecked }));
  };

  const handleExpand = (newExpanded) => {
    setExpanded(newExpanded);
  };

  return (
    <div className={`tree-comp w-full ${viewOnly ? "disabled" : ""}`}>
      <CheckboxTree
        nodes={data}
        checked={localChecked}
        expanded={expanded}
        disabled={viewOnly}
        disableCheckbox={viewOnly}
        onCheck={handleCheck}
        onExpand={handleExpand}
        icons={{
          expandClose: <TreeClose />,
          expandOpen: <TreeOpen />,
        }}
      />
    </div>
  );
}

export default TreeComp;
